import React, { Component } from "react";
import "./Advertisement.css";
import ReactPaginate from "react-paginate";
import $ from "jquery";
import OutsideClickHandler from "react-outside-click-handler";
import ReactPlayer from "react-player/lazy";
import { Row, Col } from "react-bootstrap";
import { FiThumbsUp } from "react-icons/fi";
import { NotificationManager } from "react-notifications";
import {Container} from "@material-ui/core";

class Advertisement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tenders: [],
      tendersFilter: [],
      // msmeSuppliers: [],
      offset: 0,
      tensdersPageCount: 1,
      perPage: 3,
      currentPage: 0,
      checked: false,
      postCategoryIdVlaue: "",
      InitialAccessToken: localStorage.getItem("GlobalAccess"),
      subCategoriesList: [],
      copyOfTenders: [],
      //new added
      contentOwners: [],
    };
    this.handlePageClick = this.handlePageClick.bind(this);
    this.isComponentMounted = false

  }

  componentDidMount() {
    this.postCategoryIdValue();
  }

  postCategoryIdValue() {
    this.isComponentMounted = true;
    fetch(
      `${window.appConfig.getContentCategories}${window.appConfig.Relam}${window.appConfig.Relam}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (!this.isComponentMounted) return; // Ensure the component is still mounted
  
        const postid = result.categoryList.filter(
          (data) => data.categoryname === "ADVERTISEMENTS"
        );
  
        if (postid.length === 0) {
          console.warn("No matching category found");
          return;
        }
  
        const categoryId = postid[0].categoryid;
  
        this.viewAllAdvertisements(categoryId);
        this.setState({
          postCategoryIdValue: categoryId, // Fixed typo
        });
        this.adminsDropdownClick(categoryId);
        this.getCategorySubcategories(categoryId);
        this.ownerDropdownClick(categoryId);
      })
      .catch((err) => console.log("Fetch error:", err));
  }
  componentWillUnmount(){
    this.isComponentMounted = false
  }

  viewAllAdvertisements(postid) {
    fetch(
      `${window.appConfig.getContentList}${window.appConfig.Relam}category/${postid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          copyOfTenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }
  // changes done
  adminsDropdownClick(catID) {
    fetch(
      // `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`,
      `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        const unique = [
          ...new Map(
            result.contentcreatorsList.map((data) => [
              data.contentcreatorid,
              data,
            ])
          ).values(),
        ];
        this.setState({
          tendersFilter: unique,
        });
      })
      .catch((err) => console.log("err", err));
  }

  organizationsDropdownClick() {
    $("#dropdownOrganizations").toggle();
  }

  organizationsOnClick(Creator) {
    fetch(
      `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`,
      // `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      })
      .catch((err) => console.log("err", err));
    $("#dropdownOrganizations").hide();
  }

  // end changes done

  getCategorySubcategories(catID) {
    if(!catID) return
    fetch(`${window.appConfig.getContentSubcategories}${window.appConfig.Relam}${window.appConfig.Relam}${window.appConfig.Relam}${catID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())    
      .then((result) => {
        
        this.setState({
          subCategoriesList: result.contentsubcategories,
        });
      })
      .catch((err) => console.log("err", err));
  }

  subCategoriesDropdownClick() {
    $("#subCategoriesOfAds").toggle();
  }
  // Content Owner
  ownerDropdownClick(catID) {
    fetch(
      `${window.appConfig.getAllContentOwnersBasedOnCategory}${catID}`,
      // `${window.appConfig.getContentCreator}${window.appConfig.Relam}contentcreators/${catID}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        const unique = [
          ...new Map(
            result.contentownerList.map((data) => [data.contentowner, data])
          ).values(),
        ];
        this.setState({
          contentOwners: unique,
        });
      })
      .catch((err) => console.log("err", err));
  }

  contentOwnerDropdownClick() {
    $("#ContentOwnerOfAds").toggle();
  }

  getContentOwnerContent(Owner) {
    fetch(
      // `${window.appConfig.getContentonContentCreator}${window.appConfig.Relam}contentcreator/${Creator}/${this.state.postCategoryIdVlaue}`,
      `${window.appConfig.getContentList}${window.appConfig.Relam}contentowner/${Owner}/${this.state.postCategoryIdVlaue}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.json())
      .then((result) => {
        this.setState({
          tenders: result.contentList,
          tensdersPageCount: Math.ceil(
            result.contentList.length / this.state.perPage
          ),
        });
      })
      .catch((err) => console.log("err", err));
    $("#dropdownOrganizations").hide();
  }

  // Content Owner End

  subCategoriesOnClick(subCategory) {
    const subCategoriesOfAdsFilter = this.state.copyOfTenders.filter(
      (data, index) => {
        return data.contentsubcategory
          .toLowerCase()
          .includes(subCategory.toLowerCase());
      }
    );
    this.setState({
      tenders: subCategoriesOfAdsFilter,
      tensdersPageCount: Math.ceil(
        subCategoriesOfAdsFilter.length / this.state.perPage
      ),
    });
    $("#subCategoriesOfAds").hide();
  }

  likeCount(contentid) {
    fetch(
      `${window.appConfig.contentLikeCount}${window.appConfig.Relam}${contentid}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "text/plain",
          Authorization: "Bearer " + this.state.InitialAccessToken,
        },
      }
    )
      .then((res) => res.text())
      .then((result) => {
        this.postCategoryIdValue();
        return NotificationManager.success(result);
      })
      .catch((err) => console.log("err", err));
  }
  /*Pagination */
  handlePageClick = (e) => {
    const selectedPage = e.selected;
    const offset = selectedPage * this.state.perPage;

    this.setState(
      {
        currentPage: selectedPage,
        offset: offset,
      },
      () => {}
    );
  };
  /*End of pagination */

  render() {
    // added new
    const { tenders, tendersFilter, subCategoriesList, contentOwners } =
      this.state;
    const tendersList = tenders.slice(
      this.state.offset,
      this.state.offset + this.state.perPage
    );

    return (
<Container>
      <div
        id="tendersContainer"
        className="mb-lg-5 mb-4 mt-4 gbr-engage-container container-fluid"
      >
        {/* <h3 className="container-title">Advertisements</h3> */}
        <div className="mb-4 ">
          <div className="dropdown">
            <div className="navbarRight">
              <button
                className="btn btn-success homepageBtn"
                type="button"
                onClick={() =>
                  this.viewAllAdvertisements(this.state.postCategoryIdVlaue)
                }
              >
                All Advertisements
              </button>
            </div>
          </div>
          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.organizationsDropdownClick()}
                >
                  ADS Publisher
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="dropdownOrganizations"
                aria-labelledby="dropdownOrganizations"
              >
                {tendersFilter &&
                  tendersFilter.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.organizationsOnClick(filter.contentcreatorid)
                        }
                      >
                        {filter.contentcreatorid}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.subCategoriesDropdownClick()}
                >
                  Sub Categories
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="subCategoriesOfAds"
                aria-labelledby="subCategoriesOfAds"
              >
                {subCategoriesList &&
                  subCategoriesList.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.subCategoriesOnClick(
                            filter.contentsubcategoryname
                          )
                        }
                      >
                        {filter.contentsubcategoryname}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>

          <div className="dropdown">
            <div className="dropdown homepage-nav-item">
              <div className="navbarRight">
                <button
                  className="btn btn-success homepageBtn"
                  type="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                  onClick={() => this.contentOwnerDropdownClick()}
                >
                  ADS Owner
                </button>
              </div>
              <div
                className="dropdown-menu"
                id="ContentOwnerOfAds"
                aria-labelledby="ContentOwnerOfAds"
              >
                {contentOwners &&
                  contentOwners.map((filter, i) => (
                    <li key={i}>
                      <a
                        className="dropdown-item"
                        role="button"
                        onClick={() =>
                          this.getContentOwnerContent(filter.contentowner)
                        }
                      >
                        {filter.contentowner}
                      </a>
                    </li>
                  ))}
              </div>
            </div>
          </div>
        </div>
        <div className="adminTendersDiv">
          {/* View All Advertisements */}
          {tendersList.length !== 0 ? (
            <Row className="justify-content-center">
              {/* {tendersList.map((tend, index) => (
                <div className="videosWrapper">
                  <div className="card cardContent w-100 m-0">
                    <div className="card-body card-body-wrapper ">
                      <p>
                        <b>Assetdeveloperid:</b> {tend.parentid}
                      </p>
                      <p><b>Content Id:</b> {tend.contentid}</p>
                      <p><b>Category Id:</b> {tend.categoryid}</p>
                      <p><b>Content Uploader:</b> {tend.contentcreator}</p>
                      <p><b>Category:</b> {tend.categoryname}</p>
                      <p><b>Organization:</b> {tend.contentowner}</p>
                      <p><b>Sub Categoryname:</b> {tend.contentsubcategory}</p>
                      <h6>{tend.contentdescription}</h6>
                      <p>
                        <ReactPlayer
                          className="product-video"
                          url={tend.locationurl}
                          pip={true}
                          controls={true}
                          playing={false}
                          muted={true}
                        />
                      </p>
                    </div>
                  </div>
                </div>
              ))} */}

              {tendersList.map((tend, index) => (
                <Col md={6} lg={4} sm={12} xs={12} className="mb-4" key={index}>
                  <div className="community-cards w-100">
                    <div className="bordered-div"></div>
                    <div className="pb-2">
                      <div className="scrollable-container scrollable-container-mod">
                        <div className="community-card-body">
                          {/* <span className="d-block mt-2 mb-2">
                            {tend.contentsubcategory}
                          </span> */}

                          <div className="d-flex justify-content-between align-items-center mb-2 mt-2">
                            <span className=" d-block ">
                              {tend.contentsubcategory}
                            </span>
                            <p className="products-like mb-0 d-flex align-items-end">
                              <span
                                className="d-inline-block"
                                onClick={() => {
                                  this.likeCount(tend.contentid);
                                }}
                              >
                                <FiThumbsUp size={30} />
                              </span>
                              <small>{tend.likecount}</small>
                            </p>
                          </div>
                          {/* <div className="mt-2 mb-2">
                            <span className="d-block">
                              {tend.contentsubcategory}
                            </span>
                            <span>{tend.timestamp}</span>
                          </div> */}
                          <h2 className="mb-0">{tend.contentname}</h2>

                          <h5 className="mb-2">
                            Posted by <span>{tend.contentcreatorid}</span>,{" "}
                            {tend.timestamp}
                          </h5>

                            <ReactPlayer
                              className="product-video mb-3"
                              url={tend.locationurl}
                              pip={true}
                              controls={true}
                              playing={false}
                              muted={true}
                            />
                          <a
                            className="text-decoration-none"
                            href={tend.texturl}
                            target="_blank"
                          >
                            {" "}
                            <h6 className="mb-3">{tend.contentdescription}</h6>
                          </a>
                          {/* <p className="products-like mb-0 d-flex align-items-end">
                            <span
                              className="d-inline-block"
                              onClick={() => {
                                this.likeCount(tend.contentid);
                              }}
                            >
                              <FiThumbsUp size={30} />
                            </span>
                            <small>{tend.likecount}</small>
                          </p> */}
                          {/* <p>
                          <b>Assetdeveloperid:</b> {tend.parentid}
                        </p>
                        <p>
                          <b>Content Id:</b> {tend.contentid}
                        </p>
                        <p>
                          <b>Category Id:</b> {tend.categoryid}
                        </p> */}
                          {/* <p>
                          <b>Content Uploader:</b> {tend.contentcreator}
                        </p> */}
                          {/* <p>
                            <b>Content Uploader:</b> {tend.contentowner}
                          </p> */}
                          {/* <p>
                        <b>Category:</b> {tend.categoryname}
                      </p> */}
                          {/* <p>
                        <b>Organization:</b> {tend.contentowner}
                      </p> */}
                          {/* <p>
                          <b>Sub Categoryname:</b> {tend.contentsubcategory}
                        </p> */}
                          {/* <h6>{tend.contentdescription}</h6> */}

                          {/* <a
                        className="downloadDocument"
                        href={tend.locationurl}
                        download
                      >
                        Download Document
                      </a> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              ))}
              <div className="paginationComponent">
                <ReactPaginate
                  previousLabel={"<<"}
                  nextLabel={">>"}
                  breakLabel={"..."}
                  breakClassName={"break-me"}
                  pageCount={this.state.tensdersPageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={this.handlePageClick}
                  containerClassName={"pagination"}
                  subContainerClassName={"pages pagination"}
                  activeClassName={"active"}
                />
              </div>
            </Row>
          ) : (
            <div className="card">
              <p className="card-body container-heading2">
                <b>Advertisement's Not Found</b>
              </p>
            </div>
          )}
        </div>
        <OutsideClickHandler
          onOutsideClick={() => {
            $("#dropdownOrganizations").hide();
            $("#subCategoriesOfAds").hide();
            // content owner
            $("#ContentOwnerOfAds").hide();
          }}
        ><></></OutsideClickHandler>
      </div>
      </Container>
    );
  }
}

export default Advertisement;
